import { LibItem } from "../types";
import BackendConnect from "./connect";

export class BackendLibService extends BackendConnect {
    protected static instance: BackendLibService;

    constructor(headers: Record<string, string>) {
        super(headers);
      }
    
      static getInstance(): BackendLibService {
        if (!BackendLibService.instance) {
          BackendLibService.instance = new BackendLibService({});
          const bearerToken = localStorage.getItem("bearerToken");
          if (bearerToken) {
            BackendLibService.instance.setAccessToken(bearerToken);
          }
        }
        return BackendLibService.instance;
      }

    public async getEventTypeList() : Promise<{ kinds: LibItem[]}> {
        return this.get("/lib/eventkinds");
    }

    public async getPermissionList() : Promise<{permissions: LibItem[]}> {
       return this.get("/roles/permissionlist");
    }
}

export const libBackend = BackendLibService.getInstance();